module.exports = __webpack_public_path__ + "img/Sprouts_Logo_4C13.a78a1772.png";